import { createToaster } from "@chakra-ui/react";

export const toaster = createToaster({
  placement: "top",
});
